function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1875 16.3275L16.8225 19.125L15.5925 13.8525L19.6875 10.305L14.295 9.8475L12.1875 4.875L10.08 9.8475L4.6875 10.305L8.7825 13.8525L7.5525 19.125L12.1875 16.3275Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.1875 16.3275L44.8225 19.125L43.5925 13.8525L47.6875 10.305L42.295 9.8475L40.1875 4.875L38.08 9.8475L32.6875 10.305L36.7825 13.8525L35.5525 19.125L40.1875 16.3275Z",
  fill: "#666666"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M68.1875 16.3275L72.8225 19.125L71.5925 13.8525L75.6875 10.305L70.295 9.8475L68.1875 4.875L66.08 9.8475L60.6875 10.305L64.7825 13.8525L63.5525 19.125L68.1875 16.3275Z",
  fill: "#666666"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M96.1875 16.3275L100.823 19.125L99.5925 13.8525L103.688 10.305L98.295 9.8475L96.1875 4.875L94.08 9.8475L88.6875 10.305L92.7825 13.8525L91.5525 19.125L96.1875 16.3275Z",
  fill: "#666666"
});

function SvgFourStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 24,
    viewBox: "0 0 108 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourStars);
export default __webpack_public_path__ + "static/media/FourStars.2c078fc7.svg";
export { ForwardRef as ReactComponent };